import * as React from "react";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

import CommunityContributionsChart from "./Charts/CommunityContributionsChart";

import Circle from "../../../../components/Icons/Circle";

import { StyledItemGraph } from "../../../../components/styles/StyledItemGraph";
import { Bubble } from "../../../../components/Icons/Bubble";

import theme from "../../../../components/styles/theme/theme";

export const CommunitySection: React.FC = () => {
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return !isSmScreen ? (
    <>
      <Box id="communitySection" sx={{ flexGrow: 1, padding: "130px 25px 0px 25px" }}>
        <Grid item xs={2} sm={2} md={1}>
          <Box sx={{ width: 1 }}>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
              <Box gridColumn="span 12">
                <StyledItemGraph>
                  <CommunityChartSection />
                </StyledItemGraph>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Box>
    </>
  ) : (
    <CommunityChartSection />
  );
};

const CommunityChartSection: React.FC = () => {
  const { t } = useTranslation();
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      spacing={{ xs: 2, md: 2 }}
      columns={{ xs: 13, sm: 13, md: 13 }}
      justifyContent="center"
      padding="20px 40px"
    >
      <Grid
        item
        xs={13}
        sm={13}
        md={13}
        paddingBottom={!isSmScreen ? "40px" : "10px"}
      >
        <Typography
          variant="h5"
          component="h5"
          fontWeight="600"
          color={(theme) => theme.palette.secondary.main}
        >
          {t("charts.community_contributions")}
        </Typography>
        <Typography
          variant="body2"
          component="p"
          color={(theme) => theme.palette.primary["500"]}
          sx={{ marginTop: "4px" }}
        >
          by focus area in % and $
        </Typography>
      </Grid>

      <Grid
        item
        xs={13}
        sm={13}
        md={10}
        textAlign="start"
        sx={{ margin: "0 auto" }}
      >
        <Box padding={!isSmScreen ? "25px" : 0} maxWidth="900px" margin="0 auto">
          <CommunityContributionsChart />
        </Box>
      </Grid>
    </Grid>
  );
};
